'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    ROUTE_TO_VISTA_CLIENTE,
    RESET_STATE_DATOS_CUENTA,
    GET_DATA_CUENTA_DATA_RESULT,
    GET_DATOS_CUENTA_DATA,
    GET_SALDOS_MOVIMIENTOS,
    SELECCIONAR_COMPONENTE,
    SET_USER_FUNCTIONS_DATOS_CUENTA,
    OPEN_MODAL_DATOS_CUENTA,
    GET_PARAMETRO_GENERAL_CUENTA_CORRIENTE,
    MOSTRAR_SPINNER,
    CANCEL_NOVEDAD,
    SAVE_NOVEDAD,
    RECHAZA_ADMINISTRADORA,
    ACEPTA_ADMINISTRADORA,
    SELECCIONAR_VALOR_CAMPO,
    EDITANDO_CAMPO_CUENTA,
    ACTUALIZAR_ESTADO_NOVEDAD,
    GET_LOG_MODIFICACIONES_CUENTA,
    DENIEGA_NOVEDAD,
    LIMPIAR_STORE_COMPONENTE,
    MODAL_SECCION,
    EDICION_CAMPO_SECCION,
    LIMPIAR_PROPIEDADES_MODAL,
    CHECK_SECCION,
    VALOR_TEXT_AREA,
    GUARDAR_NOVEDAD_PARA_DENEGAR,
    MODAL_INFO,
    DATOS_LOG_INTENTOS,
    GET_DATOS_ACTUALIZADOS,
    SETEAR_SESION,
} from '../../Screens/DatosCuenta/actions/Actions';

import { GET_DATOS_GENERALES_CUENTA, ESTA_GUARDANDO } from '../../Screens/DatosCuenta/actions/DatosGeneralesCuentaActions';

import {
    ACTUALIZAR_FECHA_SALDOS_MOV,
    ACTUALIZAR_SALDOS_PARA_MOSTRAR,
    FOMARTO_FECHA_SALDOS,
    ACTUALIZA_FECHA,
    OCULTAR_MODAL,
    REINICIAR_FECHAS,
    GET_SALDOS_MOVIMIENTOS_BUSQUEDA,
    ACTUALIZAR_SALDOS_PARA_MOSTRAR_BUSQUEDA,
    LOADING,
    OCULTAR_MODAL_ADVERTENCIA, 
    CAMBIAR_MES,
    SELECCIONAR_RADIO
} from '../../Screens/DatosCuenta/actions/SaldosMovimientosActions';

import {
    GET_DATA_INTEGRANTES,
    TIENE_HISTORIAL_TARJETAS,
    GET_HISTORIAL_TARJETAS,
    ABRIR_POPUP,
    RESULTADO_ACCION_TARJETA,
    ERROR_VALIDACION_INTEGRANTES,
    ACTUALIZAR_INTEGRANTES,
    CHECK_REIMPRESION_TARJETA,
} from '../../Screens/DatosCuenta/actions/IntegrantesActions';

import {
    GET_AUTORIZACIONES_RECHAZADAS,
    GET_AUTORIZACIONES_RECHAZADAS_BUSQUEDA,
    ACTUALIZAR_AUTORIZACIONES_RECHAZADAS,
    ACTUALIZAR_AUTORIZACIONES_RECHAZADAS_BUSQUEDA,
    LOADING_AUTORIZACIONES,
    ACTUALIZA_FECHA_AUTORIZACIONES,
    ERROR_FOMARTO_FECHA_AUTORIZACIONES,
    ERROR_FECHA_POSTERIOR_AUTORIZACIONES,
    ERROR_FECHA_AUTORIZACIONES,
    AUTORIZACIONES_RANGO_DIAS,
    OCULTAR_MODAL_AUTORIZACIONES,
    REINICIAR_FECHAS_AUTRIZACIONES,
    MOSTRAR_CALENDARIOS_AUTORIZACIONES,
    MOSTRAR_DATOS_AUTORIZACIONES,
    OCULTAR_DATOS_AUTORIZACIONES,
} from '../../Screens/DatosCuenta/actions/ActionsAutorizacionesRechazadas';

import { GET_SCREEN_DATA_BAJA, SELECT_VALOR_BAJA, SOLICITAR_BAJA_PREPAGA, CANCELAR_CONFIRMADOR_BAJA, OCULTAR_SPINNER } from '../../Screens/DatosCuenta/actions/BajaCuentaPrepagaActions';

const initialState = {
    GET_DATOS_CUENTA_DATA: null,
    componenteActual: 1,
    IntegrantesCuenta: {
        integrantes: null,
        entidadTipo: 2,
        novedadRechazadaId: [],
        novedadDenegadaId: [],
        resultadoOperacion: null,
        nuevoPin: '',
        solicitaReimpresion: false,
        validaciones: {
            PIN: true,
        },
    },
    datosCuentaGenerales: {
        SucursalesCuenta: null,
        GruposAfinidadCuenta: null,
        entidadTipo: 1,
        redirectToVistaCliente: false,
        seEstaEditando: false,
        SucursalId: null,
        SucursalDescripcion: null,
        GrupoAfinidadId: null,
        GrupoAfinidadDescripcion: null,
        CuentaTarjetaId: null,
        cuentaTarjetaEstadoId: null,
        CuentaCorriente: null,
        novedadesCuentaDatos: [],
        valorAnterior: undefined,
        valorSelectIdSeleccionado: undefined,
        novedadRechazadaId: [],
        novedadDenegadaId: [],
        executionContext: null,
        valorTxtArea: 'Ingrese motivo...',
        novedadParaDenegar: {},
        datosLogIntentos:[]
    },
    bajaCuentaPrepaga: {
        motivosBaja: [],
        motivoBajaId: null,
        comentarioBaja: null,
    },
    funcionesDelUsuario: null,
    ingresoAjustesFuncionesUsuario: null,
    loading: false,
    redirect: {
        shouldRedirect: false,
        to: null,
    },
    esNovedadEditada: [
        { campoCodigo: 'SUCUR_CUEN', editado: false }, //Descripcion Empresa
        { campoCodigo: 'GRUPA_CUEN', editado: false }, //Denominación Empresa
    ],
    AutorizacionesRechazadas: {
        autorizacionesRechazadas: [],
        autorizacionesRechazadasBusqueda: [],
        autorizacionesParaMostrar: [],
        loading: false,
        limpiarFechas: false,
        SinAutorizaciones: false,
        mostrarCalendariosAutorizaciones: true,
        errorFechaDesdeAutorizaciones: false,
        errorFechaHastaAutorizaciones: false,
        FechaDesdePosteriorAutorizaciones: false,
        FechaHastaPosteriorAutorizaciones: false,
        formatoFechaDesdeAutorizaciones: false,
        formatoFechaHastaAutorizaciones: false,
        BusquedaAutorizaciones: false,
        getAutorizaciones: false,
        f: false,
        indiceAutorizaciones: 10,
        mensajeSinAutorizaciones: '',
        msjErrorCalendarioDesde: '',
        msjErrorCalendarioHasta: '',
        mensajeAutorizaciones: '',
        textoToolTip: 'Para ver autorizaciones rechazadas anteriores a los últimos 90 días, utilice la búsqueda por rango de fecha específica',
        textoInputDesde: 'Seleccione la fecha...',
        textoInputHasta: 'Seleccione la fecha...',
        fechaDesde: new Date(),
        fechaHasta: new Date(),
    },
    SaldosMovimientos: {
        DiasSaldosMovimientos: 7,
        Saldos: [],
        SaldosBusqueda: [],
        SaldosParaMostrar: [],
        MovimientosSinConfirmar: {
            totalAjustesCargos:0,
            totalAutorizaciones:0,
            movimientosSinConfirmar:[]
        },
        IndiceSaldos: 10,
        SaldoAdintar: undefined,
        SinSaldoParaMostrar: false,
        msjErrorCalendarioSaldos: 'Formato incorrecto', 
        mensajeSaldos: "La fecha debe ser mayor al 03/2020 y menor o igual a la fecha actual. La misma debe contar con un formato MM/AAAA",
        mostrarModalSaldos: false,
        fecha: new Date(),
        radioBtnSaldos: 'P',
        fechaSaldosFormatoOk: true, 
        BusquedaMovimientos: false,
        loading: false,
        mostrarCalendarios: true,
        mensajeSinSaldo: '',
        mostrarModalAdvertencia: true,
        datosActualizados: undefined,
    },
    modalInfo: {
        titulo: '',
        mensaje: '',
        mostrar: false,
    },
    modalHistorialModificaciones: false,
    modalHistorialTarjetas: false,
    modalDenegacionDeCuenta: false,
    modalLogIntentos: false,
    IdmodalLogIntentos: undefined,
    modalPermisoIngresoAjustes: false,
    tieneHistorialTarjeta: true,
    HistorialTarjetas: {
        Tarjetas: [],
    },
    datosHistorialModificaciones: null,
    sesion: undefined,
    currentScope: undefined
};

function DatosCuenta(state = initialState, action) {
    LogHelper.In(DatosCuenta.name, state, action);

    let result;

    function setearEstiloAutorizaciones(array) {
        let index = 0;
        array.forEach(function (elemento) {
            if (elemento.mostrarDatos == undefined) {
                elemento.clase = index % 2 != 0 ? ' backgroundTableLightBlue' : '';
                index++;
            }
        });
    }

    switch (action.type) {

        case GET_DATOS_ACTUALIZADOS:{
            let dataFinal = "No Disponible.";
            let fechaAux, dia, mes, anio;

            if(action.data && action.data.FechaArchivo){
                fechaAux = action.data.FechaArchivo.toString().substr(0,10).split("-");
                dia = fechaAux[2];
                mes = fechaAux[1];
                anio = fechaAux[0];

                dataFinal = dia + "/" + mes + "/" + anio;
            }   

            result = {
                ...state,
                SaldosMovimientos:{
                    ...state.SaldosMovimientos,
                    datosActualizados: dataFinal
                }
            };
            break;
        }

        case GET_AUTORIZACIONES_RECHAZADAS: {
            state.AutorizacionesRechazadas.autorizacionesRechazadas = action.Autorizaciones.autorizacionesRechazadas;
            state.AutorizacionesRechazadas.SinAutorizaciones =
                state.AutorizacionesRechazadas.autorizacionesRechazadas && state.AutorizacionesRechazadas.autorizacionesRechazadas.length <= 10 ? true : false;
            state.AutorizacionesRechazadas.autorizacionesParaMostrar = state.AutorizacionesRechazadas.autorizacionesRechazadas.slice(0, state.AutorizacionesRechazadas.indiceAutorizaciones);
            state.AutorizacionesRechazadas.mensajeSinAutorizaciones = state.AutorizacionesRechazadas.SinAutorizaciones
                ? 'No existen autorizaciones rechazadas para la cuenta en los últimos 90 días. Si lo desea, puede consultar un rango específico de fechas anterior.'
                : '';

            setearEstiloAutorizaciones(state.AutorizacionesRechazadas.autorizacionesParaMostrar);

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                },
            };
            break;
        }

        case GET_AUTORIZACIONES_RECHAZADAS_BUSQUEDA: {
            state.AutorizacionesRechazadas.indiceAutorizaciones = 10;
            state.AutorizacionesRechazadas.autorizacionesRechazadasBusqueda = action.Autorizaciones.autorizacionesRechazadas;
            state.AutorizacionesRechazadas.SinAutorizaciones =
                state.AutorizacionesRechazadas.autorizacionesRechazadasBusqueda && state.AutorizacionesRechazadas.autorizacionesRechazadasBusqueda.length <= 10 ? true : false;
            state.AutorizacionesRechazadas.autorizacionesParaMostrar = state.AutorizacionesRechazadas.autorizacionesRechazadasBusqueda.slice(0, state.AutorizacionesRechazadas.indiceAutorizaciones);
            state.AutorizacionesRechazadas.BusquedaAutorizaciones = true;
            state.AutorizacionesRechazadas.textoToolTip = state.AutorizacionesRechazadas.SinAutorizaciones
                ? 'No existen movimientos para la cuenta en el período indicado.'
                : 'No existen más movimientos para la cuenta en el período indicado. Si lo desea, puede consultar otro rango de fechas.';
            state.AutorizacionesRechazadas.mensajeSinAutorizaciones = 'No existen movimientos para la cuenta en el período indicado. Consulte otro rango de fechas.';

            setearEstiloAutorizaciones(state.AutorizacionesRechazadas.autorizacionesParaMostrar);

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                },
            };
            break;
        }

        case MOSTRAR_DATOS_AUTORIZACIONES: {
            let autorizacionAux;

            autorizacionAux = JSON.parse(JSON.stringify(state.AutorizacionesRechazadas.autorizacionesParaMostrar.filter((e, i) => action.index == i)));

            autorizacionAux = autorizacionAux[0];
            autorizacionAux.mostrarDatos = action.mostrarDatos;
            state.AutorizacionesRechazadas.autorizacionesParaMostrar.splice(action.index + 1, 0, autorizacionAux);
            setearEstiloAutorizaciones(state.AutorizacionesRechazadas.autorizacionesParaMostrar);
            state.AutorizacionesRechazadas.autorizacionesParaMostrar[action.index].flechaArriba = action.mostrarDatos;

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                },
            };
            break;
        }

        case OCULTAR_DATOS_AUTORIZACIONES: {
            let indiceEliminar = action.index + 1;

            //elimino el elemento que se oculto del array
            state.AutorizacionesRechazadas.autorizacionesParaMostrar.splice(indiceEliminar, 1);
            setearEstiloAutorizaciones(state.AutorizacionesRechazadas.autorizacionesParaMostrar);
            state.AutorizacionesRechazadas.autorizacionesParaMostrar[action.index].flechaArriba = action.mostrarDatos;

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                },
            };
            break;
        }

        case ACTUALIZAR_AUTORIZACIONES_RECHAZADAS: {
            state.AutorizacionesRechazadas.indiceAutorizaciones += 10;
            let lengthAutorizaciones = state.AutorizacionesRechazadas.autorizacionesRechazadas.length;
            let indiceAutorizaciones = state.AutorizacionesRechazadas.indiceAutorizaciones;

            if (indiceAutorizaciones == lengthAutorizaciones || indiceAutorizaciones > lengthAutorizaciones) state.AutorizacionesRechazadas.SinAutorizaciones = true;
            else state.AutorizacionesRechazadas.SinAutorizaciones = false;

            state.AutorizacionesRechazadas.autorizacionesParaMostrar = state.AutorizacionesRechazadas.autorizacionesRechazadas.slice(0, state.AutorizacionesRechazadas.indiceAutorizaciones);

            setearEstiloAutorizaciones(state.AutorizacionesRechazadas.autorizacionesParaMostrar);

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                },
            };
            break;
        }

        case ACTUALIZAR_AUTORIZACIONES_RECHAZADAS_BUSQUEDA: {
            state.AutorizacionesRechazadas.indiceAutorizaciones = state.AutorizacionesRechazadas.indiceAutorizaciones + 10;
            let length = state.AutorizacionesRechazadas.autorizacionesRechazadasBusqueda.length;
            let indice = state.AutorizacionesRechazadas.indiceAutorizaciones;

            if (indice == length || indice > length) state.AutorizacionesRechazadas.SinAutorizaciones = true;
            else state.AutorizacionesRechazadas.SinAutorizaciones = false;

            state.AutorizacionesRechazadas.autorizacionesParaMostrar = state.AutorizacionesRechazadas.autorizacionesRechazadasBusqueda.slice(0, state.AutorizacionesRechazadas.indiceAutorizaciones);
            state.AutorizacionesRechazadas.autorizacionesParaMostrar.map((e, i) => {
                if (e.flechaArriba) e.flechaArriba = false;
            });

            setearEstiloAutorizaciones(state.AutorizacionesRechazadas.autorizacionesParaMostrar);

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                },
            };
            break;
        }

        case LOADING_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    loading: action.valor,
                },
            };
            break;
        }

        case ACTUALIZA_FECHA_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    [action.fechaTipo]: action.valor,
                    [action.fechaFormato]: true,
                    limpiarFechas: true,
                },
            };
            break;
        }

        case ERROR_FECHA_POSTERIOR_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    [action.fechaTipo]: action.valor,
                    [action.mensajeTipo]: 'Fecha incorrecta',
                    limpiarFechas: false,
                },
            };
            break;
        }

        case ERROR_FOMARTO_FECHA_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    [action.fechaTipo]: action.valor,
                    [action.mensajeTipo]: 'Formato incorrecto',
                    limpiarFechas: false,
                },
            };
            break;
        }

        case ERROR_FECHA_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    getAutorizaciones: action.valor,
                    mensajeAutorizaciones: action.mensaje,
                },
            };
            break;
        }

        case AUTORIZACIONES_RANGO_DIAS: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    getAutorizaciones: action.valor,
                    mensajeAutorizaciones: 'Por favor seleccione un período que no supere los 90 días entre inicio y fin.',
                },
            };
            break;
        }

        case OCULTAR_MODAL_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    getAutorizaciones: false,
                },
            };
            break;
        }

        case MOSTRAR_CALENDARIOS_AUTORIZACIONES: {
            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    mostrarCalendariosAutorizaciones: action.valor,
                },
            };
            break;
        }

        case REINICIAR_FECHAS_AUTRIZACIONES: {
            state.AutorizacionesRechazadas.indiceAutorizaciones = 10;
            state.AutorizacionesRechazadas.SinAutorizaciones =
                state.AutorizacionesRechazadas.autorizacionesRechazadas && state.AutorizacionesRechazadas.autorizacionesRechazadas.length < 1 ? true : false;
            state.AutorizacionesRechazadas.autorizacionesParaMostrar = state.AutorizacionesRechazadas.autorizacionesRechazadas.slice(0, state.AutorizacionesRechazadas.indiceAutorizaciones);
            state.AutorizacionesRechazadas.mensajeSinAutorizaciones =
                'No existen autorizaciones rechazadas para la cuenta en los últimos 90 días. Si lo desea, puede consultar un rango específico de fechas anterior.';
            state.AutorizacionesRechazadas.BusquedaAutorizaciones = false;
            state.AutorizacionesRechazadas.limpiarFechas = false;
            state.AutorizacionesRechazadas.formatoFechaDesdeAutorizaciones = false;
            state.AutorizacionesRechazadas.formatoFechaHastaAutorizaciones = false;

            result = {
                ...state,
                AutorizacionesRechazadas: {
                    ...state.AutorizacionesRechazadas,
                    fechaDesde: new Date(),
                    fechaHasta: new Date(),
                    textoToolTip: 'Para ver movimientos anteriores a los últimos 90 días, utilice la búsqueda por rango de fecha específica.',
                },
            };
            break;
        }

        case ACTUALIZAR_FECHA_SALDOS_MOV: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    DiasSaldosMovimientos: state.SaldosMovimientos.DiasSaldosMovimientos + 7,
                },
            };
            break;
        }

        case LOADING: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    loading: action.valor,
                },
            };
            break;
        }

        case REINICIAR_FECHAS: {
            state.SaldosMovimientos.IndiceSaldos = 10;
            state.SaldosMovimientos.SinSaldoParaMostrar = state.SaldosMovimientos.Saldos && state.SaldosMovimientos.Saldos.length < 1 ? true : false;
            state.SaldosMovimientos.SaldosParaMostrar = state.SaldosMovimientos.Saldos.slice(0, state.SaldosMovimientos.IndiceSaldos);
            state.SaldosMovimientos.mensajeSinSaldo = 'No existen movimientos para la cuenta en los últimos 90 días. Si lo desea, puede consultar un rango específico de fechas anterior.';
            state.SaldosMovimientos.BusquedaMovimientos = false;
            state.SaldosMovimientos.fechaSaldosFormatoOk = false;

            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    fecha: new Date()
                },
            };
            break;
        }

        case OCULTAR_MODAL: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    mostrarModalSaldos: false,
                },
            };
            break;
        }

        case OCULTAR_MODAL_ADVERTENCIA: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    mostrarModalAdvertencia: false,
                },
            };
            break;
        }
 
        case ACTUALIZA_FECHA: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    fecha: action.valor,
                    fechaSaldosFormatoOk: true,
                },
            };
            break;
        }

        case FOMARTO_FECHA_SALDOS: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    fechaSaldosFormatoOk: action.valor,
                    mostrarModalSaldos: action.mostrarModalSaldos
                },
            };
            break;
        }

        case GET_SALDOS_MOVIMIENTOS: {
            //Movimientos Confirmados
            state.SaldosMovimientos.fecha = new Date();
            state.SaldosMovimientos.Saldos = action.SaldosMov.Saldos;
            state.SaldosMovimientos.SinSaldoParaMostrar = state.SaldosMovimientos.Saldos && state.SaldosMovimientos.Saldos.length <= 10 ? true : false;
            state.SaldosMovimientos.SaldoAdintar = action.SaldosMov.SaldoAdintar17;
            state.SaldosMovimientos.SaldosParaMostrar = state.SaldosMovimientos.Saldos.slice(0, state.SaldosMovimientos.IndiceSaldos);
            state.SaldosMovimientos.mensajeSinSaldo = 'Sin Movimientos';

            //Movimientos sin confirmar
            state.SaldosMovimientos.MovimientosSinConfirmar = action.SaldosMov.MovimientosSinConfirmar;
       
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                },
            };
            break;
        }

        case GET_SALDOS_MOVIMIENTOS_BUSQUEDA: {
            state.SaldosMovimientos.IndiceSaldos = 10;
            state.SaldosMovimientos.SaldosBusqueda = action.SaldosMov.Saldos;
            state.SaldosMovimientos.SinSaldoParaMostrar = state.SaldosMovimientos.SaldosBusqueda && state.SaldosMovimientos.SaldosBusqueda.length <= 10 ? true : false;
            state.SaldosMovimientos.SaldosParaMostrar = state.SaldosMovimientos.SaldosBusqueda.slice(0, state.SaldosMovimientos.IndiceSaldos);
            state.SaldosMovimientos.BusquedaMovimientos = true;            
            state.SaldosMovimientos.mensajeSinSaldo = 'Sin Movimientos.';
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                },
            };
            break;
        }

        case ACTUALIZAR_SALDOS_PARA_MOSTRAR: {
            state.SaldosMovimientos.IndiceSaldos = state.SaldosMovimientos.IndiceSaldos + 10;
            let lengthSaldos = state.SaldosMovimientos.Saldos.length;
            let indiceSaldos = state.SaldosMovimientos.IndiceSaldos;

            if (indiceSaldos == lengthSaldos || indiceSaldos > lengthSaldos) state.SaldosMovimientos.SinSaldoParaMostrar = true;
            else state.SaldosMovimientos.SinSaldoParaMostrar = false;

            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    SaldosParaMostrar: state.SaldosMovimientos.Saldos.slice(0, state.SaldosMovimientos.IndiceSaldos),
                },
            };
            break;
        }

        case ACTUALIZAR_SALDOS_PARA_MOSTRAR_BUSQUEDA: {
            state.SaldosMovimientos.IndiceSaldos = state.SaldosMovimientos.IndiceSaldos + 10;
            let lengthSaldos = state.SaldosMovimientos.SaldosBusqueda.length;
            let indiceSaldos = state.SaldosMovimientos.IndiceSaldos;

            if (indiceSaldos == lengthSaldos || indiceSaldos > lengthSaldos) state.SaldosMovimientos.SinSaldoParaMostrar = true;
            else state.SaldosMovimientos.SinSaldoParaMostrar = false;

            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    SaldosParaMostrar: state.SaldosMovimientos.SaldosBusqueda.slice(0, state.SaldosMovimientos.IndiceSaldos),
                },
            };
            break;
        }

        case CAMBIAR_MES: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    fecha: action.fecha
                },
            };
            break;
        }

        case SELECCIONAR_RADIO: {
            result = {
                ...state,
                SaldosMovimientos: {
                    ...state.SaldosMovimientos,
                    radioBtnSaldos: action.valor
                },
            };
            break;
        }

        case MODAL_SECCION: {
            result = {
                ...state,
                [action.seccion]: {
                    ...state[action.seccion],
                    modalAbierto: action.accion ? action.modal : null,
                },
            };

            if (action.nombreParam) {
                result = {
                    ...state,
                    [action.seccion]: {
                        ...state[action.seccion],
                        modalAbierto: action.accion ? action.modal : null,
                        [action.nombreParam]: action.param,
                    },
                };
            }
            break;
        }
        case CHECK_SECCION: {
            result = {
                ...state,
                [action.seccion]: {
                    ...state[action.seccion],
                    [action.prop]: !state[action.seccion][action.prop],
                },
            };
            break;
        }

        case LIMPIAR_PROPIEDADES_MODAL: {
            switch (action.seccion) {
                case 'IntegrantesCuenta': {
                    let validacionesAux = Object.assign({}, initialState.IntegrantesCuenta.validaciones);
                    result = {
                        ...state,
                        [action.seccion]: {
                            ...state[action.seccion],
                            nuevoPin: '',
                            validaciones: validacionesAux,
                        },
                    };
                    break;
                }
                default:
                    result = {
                        ...state,
                    };
                    break;
            }
            break;
        }
        case EDICION_CAMPO_SECCION: {
            result = {
                ...state,
                [action.seccion]: {
                    ...state[action.seccion],
                    [action.campo]: action.valor,
                },
            };

            break;
        }

        case GET_SCREEN_DATA_BAJA: {
            result = {
                ...state,
                bajaCuentaPrepaga: {
                    ...state.bajaCuentaPrepaga,
                    motivosBaja: action.datos.motivosBaja,
                },
            };
            break;
        }

        case RESULTADO_ACCION_TARJETA: {
            switch (action.tipoAccion) {
                case 'PIN': {
                    result = {
                        ...state,
                        IntegrantesCuenta: {
                            ...state.IntegrantesCuenta,
                            modalAbierto: 'PIN-RESULTADO',
                            resultadoOperacion: action.resultado,
                            nuevoPin: '',
                            tarjetaBlanqueo: null,
                        },
                    };
                    break;
                }
                case 'ESTADO-TARJETA-BLOQUEO-TEMPORAL':
                case 'ESTADO-TARJETA-NORMAL': {
                    if (!action.resultado) {
                        result = {
                            ...state,
                            IntegrantesCuenta: {
                                ...state.IntegrantesCuenta,
                                modalAbierto: 'BLOQUEO-RESULTADO',
                                resultadoOperacion: false,
                                tarjetaBloqueo: null,
                            },
                        };
                    } else {
                        result = {
                            ...state,
                            IntegrantesCuenta: {
                                ...state.IntegrantesCuenta,
                                modalAbierto: null,
                                resultadoOperacion: null,
                                tarjetaBloqueo: null,
                            },
                        };
                    }

                    break;
                }
                default: {
                    result = state;
                    break;
                }
            }
            break;
        }

        case SELECT_VALOR_BAJA: {
            result = {
                ...state,
                bajaCuentaPrepaga: {
                    ...state.bajaCuentaPrepaga,
                    [action.campo]: action.valor,
                },
            };
            break;
        }

        case ERROR_VALIDACION_INTEGRANTES: {
            let valAux = Object.assign({}, state.IntegrantesCuenta.validaciones);
            valAux[action.campo] = action.valida;

            result = {
                ...state,
                IntegrantesCuenta: {
                    ...state.IntegrantesCuenta,
                    validaciones: valAux,
                },
            };
            break;
        }

        case MOSTRAR_SPINNER: {
            result = {
                ...state,
                loading: true,
            };
            break;
        }

        case OCULTAR_SPINNER: {
            result = {
                ...state,
                loading: false,
            };
            break;
        }
        case GET_PARAMETRO_GENERAL_CUENTA_CORRIENTE: {
            result = {
                ...state,
                parametroGeneral: action.parametroGeneral,
            };
            break;
        }
        case OPEN_MODAL_DATOS_CUENTA: {
            switch (action.modalId) {
                case 1: {
                    result = {
                        ...state,
                        modalHistorialModificaciones: action.accion,
                        datosHistorialModificaciones: action.datosModal,
                    };
                    break;
                }
                case 2: {
                    result = {
                        ...state,
                        modalDenegacionDeCuenta: action.seccion,
                    };
                    break;
                }
                case 3: {
                    result = {
                        ...state,
                        modalLogIntentos: action.seccion,
                        IdmodalLogIntentos: action.param
                    };
                    break;
                }
                case 4: {
                    result = {
                        ...state,
                        modalPermisoIngresoAjustes: action.mostrarModal
                    };
                    break;
                }
            }
            break;
        }

        case ABRIR_POPUP: {
            switch (action.modalId) {
                case 1: {
                    result = {
                        ...state,
                        modalHistorialTarjetas: action.abrirCerrar,
                    };
                    break;
                }
            }
            break;
        }

        case TIENE_HISTORIAL_TARJETAS: {
            result = {
                ...state,
                tieneHistorialTarjeta: action.tieneHistorialTarjeta,
            };
            break;
        }

        case GET_HISTORIAL_TARJETAS: {
            result = {
                ...state,
                HistorialTarjetas: action.HistorialTarjetas,
            };
            break;
        }

        case SET_USER_FUNCTIONS_DATOS_CUENTA:
            {
                LogHelper.In(DatosCuenta.name, state, action);

                result = {
                    ...state,
                    funcionesDelUsuario: action.functions,
                    ingresoAjustesFuncionesUsuario: action.ajustesFunctions,
                    integrantesFuncionesUsuario: action.integrantesFunciones
                };
            }
            break;

        case ROUTE_TO_VISTA_CLIENTE: {
            result = {
                ...state,
                redirect: {
                    shouldRedirect: true,
                    to: action.data,
                },
            };
            break;
        }

        case SELECCIONAR_COMPONENTE:
            {
                result = {
                    ...state,
                    componenteActual: action.componenteId,
                    tieneHistorialTarjeta: true
                };
            }
            break;
        
        case SETEAR_SESION: 
            {
                result = {
                    ...state,
                    sesion: action.sesion,
                    currentScope: action.currentScope
                };
            }
            break;
        case GET_DATOS_CUENTA_DATA:
            {
                result = {
                    ...state,
                    saldoGP: action.saldoGlobal.SaldoPesos,
                    disponibleGP: action.saldoGlobal.DisponibleCompra,
                    desdeBD: action.saldoGlobal.DesdeBD,
                };
                break;
            }
        
        case DATOS_LOG_INTENTOS:{
            result = {
                ...state,
                datosCuentaGenerales: {
                    ...state.datosCuentaGenerales,
                    datosLogIntentos: action.datosLogIntentos
                },
            };
            break;
        }

        case GUARDAR_NOVEDAD_PARA_DENEGAR: {
            let novedadAux = {};
            novedadAux.Id = action.novedadId;
            novedadAux.estadoId = action.estadoId;
            novedadAux.novedadCodigo = action.novedadCodigo;
            novedadAux.novedadTipoId = action.novedadTipoId;
            novedadAux.seccion = action.seccion;
            novedadAux.nombreCampo = action.nombreCampo;

            result = {
                ...state,
                datosCuentaGenerales: {
                    ...state.datosCuentaGenerales,
                    novedadParaDenegar: novedadAux,
                },
            };
            break;
        }

        case VALOR_TEXT_AREA: {
            result = {
                ...state,
                datosCuentaGenerales: {
                    ...state.datosCuentaGenerales,
                    valorTxtArea: action.txtArea,
                },
            };
            break;
        }

        case GET_DATA_CUENTA_DATA_RESULT: {
            //DATOS RECIBIDOS DE WS DE GLOBAL PROCESSING , Consulta de Saldo
            const { SucursalesCuenta, GruposAfinidadCuenta } = action.data;
            result = {
                ...state,
                datosCuentaGenerales: {
                    ...state.datosCuentaGenerales,
                    SucursalesCuenta,
                    GruposAfinidadCuenta,
                },
            };
            break;
        }
        case RECHAZA_ADMINISTRADORA: {
            let rechazadasAux = JSON.parse(JSON.stringify(state[action.seccion].novedadRechazadaId));
            if (!rechazadasAux.some((rec) => rec == action.novedadId)) rechazadasAux.push(action.novedadId);

            result = {
                ...state,
                loading: false,
                [action.seccion]: {
                    ...state[action.seccion],
                    novedadRechazadaId: rechazadasAux,
                },
            };
            break;
        }
        case LIMPIAR_STORE_COMPONENTE: {
            result = {
                ...state,
                [action.seccion]: {
                    ...state[action.seccion],
                    [action.campo]: null,
                    editandoCampo: false,
                    novedadRechazadaId: [],
                    novedadDenegadaId: [],
                },
            };
            break;
        }
        case DENIEGA_NOVEDAD: {
            let denegadasAux = JSON.parse(JSON.stringify(state[action.seccion].novedadDenegadaId));
            if (!denegadasAux.some((den) => den == action.novedadId)) denegadasAux.push(action.novedadId);

            result = {
                ...state,
                loading: false,
                [action.seccion]: {
                    ...state[action.seccion],
                    novedadDenegadaId: denegadasAux,
                },
            };
            break;
        }
        case GET_LOG_MODIFICACIONES_CUENTA: {
            result = {
                ...state,
                [action.seccion]: {
                    ...state[action.seccion],
                    modificacionesCuenta: action.modificaciones,
                    viendoModificacionesCampo: action.campoCodigo,
                },
            };
            break;
        }
        case RESET_STATE_DATOS_CUENTA: {
            result = initialState;

            break;
        }

        case GET_DATOS_GENERALES_CUENTA:
            {
                const {
                    SucursalesCuenta,
                    GruposAfinidadCuenta,
                    SucursalDescripcion,
                    SucursalId,
                    CuentaTarjetaId,
                    cuentaTarjetaEstadoId,
                    novedadesCuentaDatos,
                    GrupoAfinidadId,
                    CuentaCorriente,
                    executionContext,
                    saldoGlobal,
                } = action.data;

                result = {
                    ...state,
                    datosCuentaGenerales: {
                        ...state.datosCuentaGenerales,
                        SucursalesCuenta,
                        GruposAfinidadCuenta,
                        CuentaCorriente,
                        GrupoAfinidadId,
                        SucursalId,
                        SucursalDescripcion,
                        CuentaTarjetaId,
                        cuentaTarjetaEstadoId,
                        novedadesCuentaDatos,
                        executionContext,
                        saldoGlobal,
                    },
                };
            }
            break;

        case ACTUALIZAR_ESTADO_NOVEDAD:
            {
                let campoNovedad = '';
                let campoNovedadCancelada = 'deleteMe';

                campoNovedad = 'novedadesCuentaDatos';

                switch (action.seccion) {
                    case 'datosCuentaGenerales':
                        campoNovedad = 'novedadesCuentaDatos';
                        break;
                    case 'IntegrantesCuenta':
                        campoNovedad = 'novedades';
                        break;
                }

                if (state[action.seccion].novedadRechazadaId && state[action.seccion].novedadRechazadaId.length > 0) {
                    // para el caso en que se rechazó el cambio, se muestra la novedad únicamente hasta que se sale de la pantalla
                    action.novedades.map((nov) => {
                        if (state[action.seccion].novedadRechazadaId.some((rec) => rec == nov.Id) && nov.NovedadEstadoId == 6) {
                            nov.NovedadEstadoId = 21;
                        }
                    });
                }

                if (state[action.seccion].novedadDenegadaId && state[action.seccion].novedadDenegadaId.length > 0) {
                    // para el caso en que se rechazó el cambio, se muestra la novedad únicamente hasta que se sale de la pantalla
                    action.novedades.map((nov) => {
                        if (state[action.seccion].novedadDenegadaId.some((den) => den == nov.Id) && nov.NovedadEstadoId == 3) {
                            nov.NovedadEstadoId = 22;
                        }
                    });
                }

                action.novedades.map((nove) => {
                    if (nove.NovedadEstadoId > 20) {
                        if (action.novedades.some((n2) => n2.Codigo == nove.Codigo && n2.Id > nove.Id)) nove.NovedadEstadoId = nove.NovedadEstadoId == 21 ? 6 : 3;
                    }
                });

                result = {
                    ...state,
                    loading: false,
                    [action.seccion]: {
                        ...state[action.seccion],
                        [campoNovedad]: action.novedades,
                        [campoNovedadCancelada]: action.novedadesCanceladas,
                    },
                };
            }
            break;
        case ACEPTA_ADMINISTRADORA:
            let novRechazada = JSON.parse(JSON.stringify(state[action.seccion].novedadRechazadaId));
            if (novRechazada.some((rec) => rec == action.novedadId)) novRechazada = novRechazada.filter((rec) => rec != action.novedadId);

            result = {
                ...state,
                loading: false,
                [action.seccion]: {
                    ...state[action.seccion],
                    [action.campo]: action.valor,
                    novedadRechazadaId: novRechazada,
                },
            };
            break;
        case EDITANDO_CAMPO_CUENTA:
            result = {
                ...state,
                [action.seccion]: {
                    ...state[action.seccion],
                    [action.campo]: action.valor,
                    editandoCampo: !action.cierra ? action.campo : false,
                },
            };
            break;
        case SELECCIONAR_VALOR_CAMPO:
            if (action.valor != null) {
                result = {
                    ...state,
                    [action.seccion]: {
                        ...state[action.seccion],
                        [action.codigo]: action.valor,
                    },
                };
            } else {
                result = {
                    ...state,
                };
            }
            break;

        case CANCEL_NOVEDAD:
            result = {
                ...state,
                datosCuentaGenerales: {
                    ...state.datosCuentaGenerales,
                    loading: false,
                    SucursalesCuenta: JSON.parse(JSON.stringify(state.datosCuentaGenerales.SucursalesCuenta)),
                    GrupoAfinidadId: action.grupoAfinidadAnterior ? action.grupoAfinidadAnterior : JSON.parse(JSON.stringify(state.datosCuentaGenerales.GrupoAfinidadId)),
                    SucursalId: action.sucursalAnterior ? action.sucursalAnterior : JSON.parse(JSON.stringify(state.datosCuentaGenerales.SucursalId)),
                    seEstaEditando: false,
                    valorAnterior: undefined,
                    seEstaEditando: undefined,
                },
            };

            break;

        case SAVE_NOVEDAD:
            state[action.seccion].loading = false;

            result = {
                ...state,
                loading: false,
                [action.seccion]: {
                    ...state[action.seccion],
                    [action.propNovedades]: action.data,
                },
            };

            break;

        case ESTA_GUARDANDO: {
            result = {
                ...state,
                datosCuentaGenerales: {
                    ...state.datosCuentaGenerales,
                },
            };
            break;
        }

        case GET_DATA_INTEGRANTES: {
            result = {
                ...state,
                IntegrantesCuenta: {
                    ...state.IntegrantesCuenta,
                    integrantes: action.integrantesCuenta,
                    novedades: action.novedades,
                },
            };
            break;
        }

        case ACTUALIZAR_INTEGRANTES: {
            result = {
                ...state,
                IntegrantesCuenta: {
                    ...state.IntegrantesCuenta,
                    integrantes: action.integrantesCuenta,
                },
            };
            break;
        }

        case CHECK_REIMPRESION_TARJETA: {
            result = {
                ...state,
                IntegrantesCuenta: {
                    ...state.IntegrantesCuenta,
                    solicitaReimpresion: !state.IntegrantesCuenta.solicitaReimpresion,
                },
            };
            break;
        }

        case SOLICITAR_BAJA_PREPAGA: {
            debugger;
            result = {
                ...state,
                modalAbierto: action.payload,
            };

            break;
        }

        case CANCELAR_CONFIRMADOR_BAJA: {
            debugger;
            result = {
                ...state,
                modalAbierto: action.payload,
            };

            break;
        }

        case MODAL_INFO: {
            result = {
                ...state,
                modalInfo: {
                    ...state.modalInfo,
                    titulo: action.titulo,
                    mensaje: action.mensaje,
                    mostrar: action.mostrar,
                },
            };
            break;
        }

        default:
            result = {
                ...state,
            };
            break;
    }

    LogHelper.Out(DatosCuenta.name, result);
    return result;
}

export default DatosCuenta;
